import {useMsal} from "@azure/msal-react";
import React from "react";
import {Container, Nav, Navbar} from "react-bootstrap";
import {Link} from "react-router-dom";

//const  logo = require('/legeforeningenLogo.svg') as string;


function Header(){

    const auth=useMsal();

    return(
        <Navbar expand="lg" variant={"dark"} style={{background: '#1f5462'}}>
            <Container>
                <Navbar.Brand href="/">
                    <img src="/legeforeningenLogo.svg" alt="Logo" width={"190px"}/>
                   </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to={"/"}>Hjem</Nav.Link>
                        <Nav.Link as={Link} to={"/soknader"}>Søknader</Nav.Link>
                        <Nav.Link onClick={()=>{
                            const logoutRequest = {
                                account: auth.instance.getAllAccounts()[0],
                                postLogoutRedirectUri: "https://legeforeningen.no"
                            };
                            auth.instance.logoutRedirect(logoutRequest);
                        }}>Logg ut</Nav.Link>

                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}
export default Header;